
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-13c9079e&scoped=true!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Headershow.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Headershow.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-13c9079e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Headershow.vue"),
  /* scopeId */
  "data-v-13c9079e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/header/Headershow.vue
// module id = 23
// module chunks = 1